export * from './delete-tour.component';
export * from './delete-tour.component.module';